"use client";

import { useEffect } from "react";

/**
 * Fires tap events for the public profile page: one `profile_view` on mount,
 * then a `link_click` for every click that lands on an `a[data-link-id]`
 * (capture phase, so it still records when the browser navigates away).
 */
function send(payload: Record<string, unknown>) {
  const json = JSON.stringify(payload);
  if (typeof navigator !== "undefined" && navigator.sendBeacon) {
    navigator.sendBeacon(
      "/api/track",
      new Blob([json], { type: "application/json" }),
    );
    return;
  }
  void fetch("/api/track", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: json,
    keepalive: true,
  }).catch(() => {});
}

export function ProfileTracker({ handle }: { handle: string }) {
  useEffect(() => {
    send({ type: "profile_view", handle });

    function onClick(event: MouseEvent) {
      const target = event.target as HTMLElement | null;
      const anchor = target?.closest?.("a[data-link-id]");
      const linkId = Number(anchor?.getAttribute("data-link-id"));
      if (linkId) {
        send({ type: "link_click", handle, linkId });
      }
    }

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [handle]);

  return null;
}
